import { mapActions } from 'vuex';

export default {
  computed: {
    panelOptions() {
      return {
        onShow: () => this.fetchOrders(),
      };
    },
  },

  methods: {
    ...mapActions('cartPreview', ['fetchOrders']),
  },
};
